// Identifiers of specific database rows, grouped because they share one hazard:
// nothing fails to compile when the underlying record changes. Business rules,
// unit math and defaults for DB-backed fields belong elsewhere.
export const SET_QUERY_STRINGS = {
  TOP_ISSUES: 'top-issues',
  POST_ELECTION_2024: 'post-election-2024',
} as const;

export const AUTOPILOT_TO_ONE_TIME_QUERY_STRINGS: Partial<Record<string, string>> = {
  'auto-pd': 'pd',
  'auto-fh': 'fh',
  'auto-fs': 'hs',
};
